import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TodoWidgetState {
  collapsed: boolean;
  dismissed: boolean;
  x: number;
  y: number;
  widgetWidth: number;
  widgetHeight: number;
  activeCategoryId: string | null;
  expand: () => void;
  collapse: () => void;
  dismiss: () => void;
  show: () => void;
  setPosition: (x: number, y: number) => void;
  setWidgetSize: (w: number, h: number) => void;
  setActiveCategory: (id: string | null) => void;
}

export const useTodoWidget = create<TodoWidgetState>()(
  persist(
    (set) => ({
      collapsed:         true,
      dismissed:         false,
      x:                 0,
      y:                 0,
      widgetWidth:       264,
      widgetHeight:      380,
      activeCategoryId:  null,
      expand:            ()      => set({ collapsed: false }),
      collapse:          ()      => set({ collapsed: true }),
      dismiss:           ()      => set({ dismissed: true, collapsed: true }),
      show:              ()      => set({ dismissed: false }),
      setPosition:       (x, y) => set({ x, y }),
      setWidgetSize:     (w, h) => set({ widgetWidth: w, widgetHeight: h }),
      setActiveCategory: (id)   => set({ activeCategoryId: id }),
    }),
    { name: 'mynd_todo_widget' }
  )
);
